import React from 'react'
import { ReorderDialog } from 'components/common/drag-and-drop/reorder-dialog'
import {
  type LeadershipOfficerDisplayOrder,
  getLeadershipDisplayOrder,
  updateLeadershipOfficerDisplayOrder
} from 'services'

interface LeadershipOfficerDisplayOrderDialogProps {
  open: boolean
  onClose: () => void
  onDisplayOrderUpdated?: (updatedData: LeadershipOfficerDisplayOrder[]) => Promise<void>
  chamberId: number
  stateId?: number
}

const getCardText = (item: LeadershipOfficerDisplayOrder): string =>
  item.leaderName != null && item.leaderName !== ''
    ? `${item.ofcName} - ${item.leaderName}`
    : `${item.ofcName} - Vacant`

export const LeadershipOfficerDisplayOrderDialog: React.FC<LeadershipOfficerDisplayOrderDialogProps> = ({
  open,
  onClose,
  onDisplayOrderUpdated,
  chamberId,
  stateId
}) => (
  <ReorderDialog<LeadershipOfficerDisplayOrder>
    open={open}
    onClose={onClose}
    listId="leadership-officer-display-order"
    title="Officer Display Order"
    emptyText="No officers found"
    loadingText="Loading list of officer display order..."
    savingText="Saving changes..."
    fetchErrorText="Failed to load officer display order. Please try again."
    saveErrorText="Failed to update officer display order. Please try again."
    itemIdPrefix="officer-rank"
    refetchKey={`${chamberId}-${stateId ?? ''}`}
    fetchItems={async () => await getLeadershipDisplayOrder(chamberId, stateId)}
    getCardText={getCardText}
    onSave={async (orderedItems) => await updateLeadershipOfficerDisplayOrder(orderedItems)}
    onSaved={async (result) => {
      if (onDisplayOrderUpdated != null) await onDisplayOrderUpdated(result)
    }}
  />
)
